import { ChangeDetectionStrategy, Component, ElementRef, ViewChild } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { UntilDestroy } from '@ngneat/until-destroy';

import { secureFieldInputBeforeInput, secureFieldTypeFocus } from '@blaze-shared/shared-feature';
import { ButtonIconComponent } from '@blaze-shared/shared-ui';

import { BaseCellInputComponent } from '../base-cell-input.component';

@UntilDestroy()
@Component({
  selector: 'blaze-cell-input-secure-text',
  templateUrl: './cell-input-secure-text.component.html',
  styleUrls: ['./cell-input-secure-text.component.scss', '../base-cell-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, MatIcon, ButtonIconComponent],
})
export class CellInputSecureTextComponent extends BaseCellInputComponent<string> {
  @ViewChild('secureFieldInput') secureFieldInput!: ElementRef<HTMLInputElement>;
  secureFieldType: 'text' | 'password' = 'password';

  secureFieldTypeFocusFn = (stringInput: HTMLInputElement): void => {
    secureFieldTypeFocus(stringInput);
  };
  secureFieldInputBeforeInputFn = (event: InputEvent, formControl: UntypedFormControl): void => {
    secureFieldInputBeforeInput(event, formControl);
  };

  override get nativeElement(): HTMLInputElement | null {
    return this.secureFieldInput?.nativeElement || null;
  }

  changeSecureTextType(type = this.secureFieldType, $event?: Event): void {
    $event?.preventDefault();
    $event?.stopPropagation();
    this.secureFieldType = type === 'text' ? 'password' : 'text';
  }
}
